import { Stack, Typography, useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import { useScroll } from 'framer-motion';
import ScrollProgress from 'src/components/scroll-progress';
import { useLocales } from 'src/locales';
import HomeAbout from '../home-about';
import HomeAdvisor from '../home-advisor';
import HomeEcosystem from '../home-ecosystem';
import HomeHero from '../home-hero';
import HomeHowItWork from '../home-how-it-work';
import HomeNFT from '../home-nft';
import HomePartner from '../home-partner';
import HomeRoadmap from '../home-roadmap';
import HomeTeam from '../home-team';
import HomeTokenomics from '../home-tokenomics';
import HomeOurMerchants from '../home-our-marchants';

// ----------------------------------------------------------------------

export default function HomeView() {
  const theme = useTheme();
  const { scrollYProgress } = useScroll();
  const { t } = useLocales();

  return (
    <>
      <ScrollProgress scrollYProgress={scrollYProgress} />

      <HomeHero />

      <Box
        sx={{
          overflow: 'hidden',
          position: 'relative',
          bgcolor: 'background.default',
        }}
      >
        <Stack
          sx={{ background: theme.palette.primary.main, width: '100vw' }}
          py={4}
          alignItems="center"
        >
          <Box component="img" src="./logo/logo_white.png" alt="" sx={{ mb: 4, width: 300 }} />

          <Typography
            variant="h6"
            fontWeight={400}
            sx={{
              textAlign: 'center',
              color: '#fff',
              width: { xs: '100%', md: '70%' },
              margin: '0 auto',
            }}
          >
            {t('walkup_lang_007')}
          </Typography>
        </Stack>

        <HomeAbout />

        <HomeHowItWork />

        <HomeEcosystem />

        <HomeOurMerchants />

        <HomeTokenomics />

        <HomeNFT />

        <HomeRoadmap />

        <HomeTeam />

        <HomeAdvisor />

        {/* <HomeTrustedPartner /> */}

        <HomePartner />
      </Box>
    </>
  );
}
